var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MdDialogModule, MdInputModule, MdButtonModule } from '@angular/material';
import { TdDialogComponent, TdDialogTitleDirective, TdDialogActionsDirective, TdDialogContentDirective } from './dialog.component';
import { TdAlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { TdConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { TdPromptDialogComponent } from './prompt-dialog/prompt-dialog.component';
import { TdDialogService, DIALOG_PROVIDER } from './services/dialog.service';
var TD_DIALOGS = [
    TdAlertDialogComponent,
    TdConfirmDialogComponent,
    TdPromptDialogComponent,
    TdDialogComponent,
    TdDialogTitleDirective,
    TdDialogActionsDirective,
    TdDialogContentDirective,
];
var TD_DIALOGS_ENTRY_COMPONENTS = [
    TdAlertDialogComponent,
    TdConfirmDialogComponent,
    TdPromptDialogComponent,
];
export { TdDialogService, TdDialogComponent, TdDialogTitleDirective, TdAlertDialogComponent, TdConfirmDialogComponent, TdPromptDialogComponent };
var CovalentDialogsModule = (function () {
    function CovalentDialogsModule() {
    }
    return CovalentDialogsModule;
}());
CovalentDialogsModule = __decorate([
    NgModule({
        imports: [
            FormsModule,
            CommonModule,
            MdDialogModule,
            MdInputModule,
            MdButtonModule,
        ],
        declarations: [
            TD_DIALOGS,
        ],
        exports: [
            TD_DIALOGS,
        ],
        providers: [
            DIALOG_PROVIDER,
        ],
        entryComponents: [
            TD_DIALOGS_ENTRY_COMPONENTS,
        ],
    })
], CovalentDialogsModule);
export { CovalentDialogsModule };
//# sourceMappingURL=dialogs.module.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/@covalent/core/dialogs/dialogs.module.js
// module id = ../../../../@covalent/core/dialogs/dialogs.module.js
// module chunks = 4